export default {
  getAutocompletePaymentMethods: (state) => state.autocompletePaymentMethods,
  getPaymentMethods: (state) => state.paymentMethods,
  getPaymentMethod: (state) => (id) => {
    return state.paymentMethods.find(paymentMethod => paymentMethod.id === id)
  },
}